import { Advertising } from './advertisingBase'
import { AdParam } from './contanst'

export class AdBasic extends Advertising {
  create () {
    this.init()
    if (!AdParam.isDiagram) {
      this.createEvent()
    }
  }

  createEvent () {
    const container = document.querySelector(`[data-element="${this.data.id}"]`)
    const items = container.querySelectorAll('.item')
    if (items.length > 1) {
      this.createCarousel()
    }
    this.addClick(items)
    this.addPrint(items)
  }
}
